<template>
  <footer class="footer">
    版权所有 &copy; 中国社区发展网 &nbsp;
    <a href="/user/reporter">人员查询</a>
  </footer>
</template>

<script>
export default {
  name: 'mFooter'
}
</script>
